import { render } from "./AIModal.vue?vue&type=template&id=040ff052&scoped=true"
import script from "./AIModal.vue?vue&type=script&lang=ts"
export * from "./AIModal.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-040ff052"

export default script